import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { template } from '@belong/common';
import { Button, Link, Text } from '@belong/ui';
import { BASE_PATHS } from 'routes/paths';
import { getLoginUrl } from 'store/redux/middleware/login-url';
import { logOut } from 'store/redux/user/actions';
import { AGREEMENT_FLOW_STRINGS } from 'strings/agreement-flow.strings';

type WrongAccountProps = {
  user?: {
    firstName?: string;
    lastName?: string;
    email?: string;
  } | null;
};

const getSignedInAsText = (user: WrongAccountProps['user']) => {
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ');
  const email = user?.email;

  if (name && email) {
    return template(AGREEMENT_FLOW_STRINGS['wrongAccount.signedInAs'], {
      account: `${name} (${email})`,
    });
  }

  if (name || email) {
    return template(AGREEMENT_FLOW_STRINGS['wrongAccount.signedInAs'], {
      account: name || email,
    });
  }

  return AGREEMENT_FLOW_STRINGS['wrongAccount.signedInAsUnknown'];
};

export const WrongAccount = ({ user }: WrongAccountProps) => {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const [isSwitching, setIsSwitching] = useState(false);

  const handleSwitchAccount = async () => {
    setIsSwitching(true);

    const loginUrl = getLoginUrl(`${pathname}${search}`);

    try {
      await dispatch(logOut());
    } catch (err) {
      console.error(err);
    }

    window.location.assign(loginUrl);
  };

  return (
    <div className="container mt-4xl mb-5xl flex justify-center">
      <div className="flex w-full max-w-[530px] flex-col items-center gap-sm text-center">
        <Text as="h1" variant="h2" fontWeight="semibold">
          {AGREEMENT_FLOW_STRINGS['wrongAccount.title']}
        </Text>
        <Text>
          {!isSwitching && getSignedInAsText(user)}{' '}
          {AGREEMENT_FLOW_STRINGS['wrongAccount.body']}
        </Text>
        <div className="mt-xl flex w-full flex-col items-center gap-lg">
          <Button
            size="fluid"
            onClick={handleSwitchAccount}
            disabled={isSwitching}
          >
            {AGREEMENT_FLOW_STRINGS['wrongAccount.switchCTA']}
          </Button>
          <Link href={BASE_PATHS.ACCOUNTS} disabled={isSwitching}>
            {AGREEMENT_FLOW_STRINGS['wrongAccount.stayCTA']}
          </Link>
        </div>
      </div>
    </div>
  );
};
